// extracted by mini-css-extract-plugin
export default {"skeleton__container":"skeleton__container_eyTWp7fj"};